Ext.define('SA.ZIndexes', {
    singleton: true,

    order: ['legend', 'popup'],

    for(name) {
        return (this.order.indexOf(name) + 1) * 100;
    },

    forLegend() {
        return this.for('legend');
    },

    forPopup() {
        return this.for('popup');
    }
});